// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import Login from './components/auth/Login';
// Importa todos los componentes que necesitas
import Dashboard from './components/admin/Dashboard';
import Users from './components/admin/Users';
import Statistics from './components/admin/Statistics';
import Settings from './components/admin/Settings';
import Documents from './components/admin/Documents';
import Tools from './components/admin/Tools';
import Security from './components/admin/Security';

import Verificarcodigo from './components/admin/Verificarcodigo';

import Productos from './components/admin/Productos'; 
import Centroservicios from './components/admin/Centroservicios';
import Rangos from './components/admin/Rangos';


import Eventos from './components/admin/Eventos';
import ConvertAPdf from './components/admin/ConvertToPdf';
import ConvertDPdf from './components/admin/ConvertFromPdf';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Ruta pública */}
          <Route path="/login" element={<Login />} />

          {/* Rutas protegidas */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            {/* Rutas hijas del layout */}
             <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/*<Route path="users" element={<Users />} />
            <Route path="statistics" element={<Statistics />} />
            <Route path="documents" element={<Documents />} />
            <Route path="ConvertToPdf" element={<ConvertAPdf />} />
            <Route path="ConvertFromPdf" element={<ConvertDPdf />} /> */}  
            <Route path="tools" element={<Tools />} />
            <Route path="security" element={<Security />} />
            <Route path="productos" element={<Productos />} /> 
            <Route path="centroservicios" element={<Centroservicios />} /> 
            <Route path="rangos" element={<Rangos />} /> 
            <Route path="verificarcodigo" element={<Verificarcodigo />} /> 

            
            <Route path="eventos" element={<Eventos />} />
            <Route path="settings" element={<Settings />} />
            <Route path="users" element={<Users />} />

          </Route>

          {/* Redirecciones */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<div className="min-h-screen flex items-center justify-center">Página no encontrada</div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;